import SuperRepository from '../superRepository'

export default new (class PartnerCategoriesRepository extends SuperRepository {
  baseUri() {
    return 'partner_category'
  }
  saveRanges = (id, data) => this.httpClient().put(`${this.baseUri()}/${id}/ranges`, data)
})()
